import React from 'react'
import GlobalStyle from '../components/global-style'
import Header from '../components/header'
import Situation from './situation'
import PackageList from './list'
import { Column } from '../components/layout'
import SEO from '../components/seo'
import { css } from 'styled-components'

export default function Package() {
  return (
    <>
      <SEO title="选择方案" />
      <GlobalStyle />
      <Header />
      <Column
        gutter={64}
        crossAlignment="center"
        innerStyle={css`
          padding: 0 24px 64px;
        `}
      >
        <Situation />
        <PackageList />
      </Column>
    </>
  )
}
